import {combineReducers, Reducer} from 'redux';
import {TnLoaderState} from '@touchnet/react-loader';
import CodesReducer from './codes-reducer';
import SettingsReducer from './settings-reducer';
import TermReducer from './term-reducer';
import WorktagReducer from './worktag-reducer';
import {TnUserMgmtReducer} from "@touchnet/user-management";
import CurrentUserReducer from "~/state/reducers/current-user-reducer";
import DeploymentContextReducer from "~/state/reducers/deployment-context-reducer";
import AppEnvReducer from "~/state/reducers/app-env-reducer.ts";
import {AuthActions} from "@touchnet/react-auth";
import {AppRootState} from "~/state/initial-state";
import {PERSISTED_STATE_KEY} from "~/constants.ts";
import {PersistedState} from "redux-persist/es/types";
import storageSession from 'redux-persist/lib/storage/session';
import {persistReducer} from "redux-persist";
import ApiKeyReducer from "~/state/reducers/api-key-reducer.ts";

const getHash = (str: string): number => {
    let hash = 0;
    if (str.length === 0) {
        return hash;
    }
    for (let i = 0; i < str.length; i++) {
        const chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
    }
    return hash;
};
const versionHash = getHash(`${import.meta.env.VITE_APP_VERSION}` ?? '');

const persistConfig = {
    key: PERSISTED_STATE_KEY,
    storage: storageSession,
    version: versionHash,
    transforms: [],
    blacklist: ['config', 'loadingData'],
    migrate: (state: PersistedState) => {
        const persistedVersionHash = state?._persist.version;
        if (persistedVersionHash === versionHash) {
            return Promise.resolve(state);
        }

        return Promise.resolve(undefined);
    },
};

export const combinedReducer = combineReducers({
    codes: CodesReducer,
    settings: SettingsReducer,
    currentUser: CurrentUserReducer,
    terms: TermReducer,
    worktag: WorktagReducer,
    deploymentContext: DeploymentContextReducer,
    appEnv: AppEnvReducer,
    apiKey: ApiKeyReducer,
});

const allReducers = combineReducers({
    loadingData: TnLoaderState.reducer,
    tnUserMgmt: TnUserMgmtReducer,
    erp: combinedReducer,
});

export const rootReducer: Reducer<AppRootState> = (state, action) => {
    if (action.type === AuthActions.LOGOUT) {
        return allReducers(undefined, action)
    }

    return allReducers(state, action);
};

export default persistReducer(persistConfig, rootReducer);
